<template>
  <DialogSlot
    :id="id"
    :modalBtn="btnName"
    :modalBtnClass="btnClass"
    :showCloseBtn="false"
    class="dialog-slot"
    ref="approvalModal"
  >
    <div slot="content">
      <TextField
        :showColon="false"
        class="handover-approval__textarea"
        :label="$t('comment')"
        :value="comment"
        @updateValue="val => comment = val"
      />
    </div>

    <div
      slot="buttons"
      class="buttons"
    >
      <button
        type="button"
        class="btn btn--darkblue"
        @click="closeModal"
      >{{ $t('action.cancel') }}</button>
      <button
        type="button"
        class="btn btn--orange"
        @click="btnAction"
      >{{ btnName }}</button>
    </div>
  </DialogSlot>
</template>

<script>
import DialogSlot from '@/controls/DialogSlot'
import TextField from '@/controls/TextField'

export default {
  name: 'hotbApproval',
  components: {
    DialogSlot,
    TextField,
  },
  props: {
    id: String,
    btnName: String,
    btnClass: String,
    updateStatus: Function,
  },
  data () {
    return {
      comment: '',
    }
  },
  methods: {
    closeModal () {
      this.$refs.approvalModal.closeModal()
    },
    btnAction () {
      this.updateStatus(this.comment)
      this.closeModal()
    },
  },
}
</script>
<style lang="scss">
.handover-approval__textarea {
  div textarea {
    width: 100% !important;
  }
}
</style>
